import { Link } from "react-router-dom";
import { Instagram, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
          <div>
            <img src="/logo.png" alt="MARKIE 2 FRESH" className="h-10 w-auto mb-8" />
            <div className="font-head font-extrabold text-4xl md:text-5xl leading-none uppercase">
              Let's throw <span className="text-brand-orange">something</span> unforgettable.
            </div>
            <Link
              to="/tickets"
              className="inline-flex mt-8 items-center gap-2 rounded-full bg-brand-orange px-7 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:bg-brand-orangeHover transition-colors"
            >
              Grab your tickets →
            </Link>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 mb-2">Explore</div>
            <Link to="/events" className="hover:text-brand-orange transition-colors">Events</Link>
            <Link to="/gallery" className="hover:text-brand-orange transition-colors">Gallery</Link>
            <Link to="/tickets" className="hover:text-brand-orange transition-colors">Tickets</Link>
            <Link to="/guest-list" className="hover:text-brand-orange transition-colors">Guest List</Link>
            <Link to="/admin" className="text-white/40 hover:text-brand-orange transition-colors text-sm mt-1">Promoter Login</Link>
          </div>

          <div className="flex flex-col gap-3">
            <div className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 mb-2">Contact</div>
            <a href="tel:+13474354354" className="flex items-center gap-2 hover:text-brand-orange transition-colors">
              <Phone size={16} /> +1 (347) 435-4354
            </a>
            <a href="mailto:support@markie2fresh.com" className="flex items-center gap-2 hover:text-brand-orange transition-colors">
              <Mail size={16} /> support@markie2fresh.com
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-orange transition-colors">
              <Instagram size={16} /> @markie2fresh
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-white/40 text-sm font-mono">
          <span>© {new Date().getFullYear()} MARKIE 2 FRESH</span>
          <span>NEW YORK CITY — ALL NIGHT</span>
        </div>
      </div>
    </footer>
  );
}
